/**
 * @description: 艺人台费充值报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="wr-ytc-report">
        <div class="ytc-list" v-show="!showRefundDetail">
            <p class="p-hint">注：退款金额是指退回用户充值时所用的银行卡或微信/支付宝余额</p>
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="ytcTime">
                        <input type="text" class="form-control laydate-icon" v-model="ytcStartTime"> -
                        <input type="text" class="form-control laydate-icon" v-model="ytcEndTime">
                    </div>
                </div>
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="ytcShop" data-placeholder="请选择消费门店"></select>
                </div>
                <label class="list-label-4">支付类型:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="ytcPayPlatform" data-placeholder="请选择支付类型"></select>
                </div>
                <label class="list-label-2">组别:</label>
                <div class="col-md-2">
                    <input class="form-control input-readonly" placeholder="请选择组别" v-model="group_txt" ref="group_txt" readonly @click="openGroup">
                    <span class="selection-clear">×</span>
                    <span class="span-arrow" role="presentation"><b></b></span>
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-2">艺人:</label>
                <div class="col-md-2">
                    <input type="text" class="form-control" v-model="search_word" placeholder="请输入艺名/腰牌">
                </div>
                <label class="list-label-3">操作人:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="staff" data-placeholder="请选择操作人"></select>
                </div>
                <div>
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="innitYtcTable" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getYtcExportSet">导出</button>
                </div>
            </div>
            <div class="row">
                <label class="list-label-6">艺人台费小计:</label>
                <div class="list-total" ref="ytc_amount"></div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="ytcList"></table>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="ytcExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='ytcExport_allcheck' @click='ytcExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ytcExport_checkModel' value="create_time">
                            <label>台费充值时间</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ytcExport_checkModel' value="stage_name">
                            <label>充值艺人姓名</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ytcExport_checkModel' value="group_name">
                            <label>组别</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ytcExport_checkModel' value="pay_platform_name">
                            <label>支付类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ytcExport_checkModel' value="amount">
                            <label>充值金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ytcExport_checkModel' value="refund_amount">
                            <label>退款金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ytcExport_checkModel' value="admin_name">
                            <label>操作人</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='ytcExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='ytcExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- 组别列表 -->
        <div class="group-panel">
            <h3>请选择组别</h3>
            <div class="group-search pull-right">
                <input type="text" placeholder="请输入组别名称" v-model="group_name">
                <img src="../../../assets/images/group_search.png" @click="getGroupData">
            </div>
            <!-- 列表 -->
            <div class="group-list">
                <ul class="clearfix">
                    <li>
                        <input type='checkbox' v-model='group_allcheck' @click='groupCheckedAll'>
                        <label>全部组别</label>
                    </li>
                    <li v-for="item in group_checkboxData" :key="item.group_id">
                        <input type="checkbox" v-model='group_checkboxModel' :value='item.group_id'>
                        <label>{{item.group_name}}</label>
                    </li>
                </ul>
            </div>
            <div class="row">
                <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="groupBack()">返回</button>
                <button type="button" class="btn btn-flat btn-middle btn-orange" @click="groupSub()">确定</button>
            </div>
        </div>
        <!-- 退款详情 -->
        <div class="refund-detail" v-show="showRefundDetail">
            <h4>退款详情</h4>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" ref="refundList"></table>
            </div>
            <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="showRefundDetail=false">返回</button>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                ytcStartTime: "",
                ytcEndTime: "",
                ytcExport_allcheck: false,
                c_ytcExport_allcheck: false,
                ytcExport_checkModel: [],
                ytcExport_checkData: ['create_time', 'stage_name', 'pay_platform_name', 'amount', 'refund_amount', 'admin_name'],
                ytcExport_type: 1,
                group_txt: '',
                group_allcheck: false,
                c_group_allcheck: false,
                group_checkboxModel: [],
                c_group_checkboxModel: [],
                group_checkboxData: [],
                group_name: '',
                pay_type_list: [],
                search_word: '',
                showRefundDetail: false,
            }
        },
        watch: {
            group_checkboxModel: {
                handler: function(val, oldVal) {
                    if(this.group_checkboxModel.length >= this.group_checkboxData.length) {
                        this.group_allcheck = true;
                        this.c_group_allcheck = true;
                    } else {
                        this.group_allcheck = false;
                        this.c_group_allcheck = false;
                    }
                },
                deep: true
            },

            ytcExport_checkModel: {
                handler: function(val, oldVal) {
                    if(this.ytcExport_checkModel.length >= this.ytcExport_checkData.length) {
                        this.ytcExport_allcheck = true;
                        this.c_ytcExport_allcheck = true;
                    } else {
                        this.ytcExport_allcheck = false;
                        this.c_ytcExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            // 日期
            this.ytcStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.ytcEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.innitDate(); // 日期
            this.shopDatas = [];
            this.innitInput();  // 门店
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.ytcStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.ytcEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.ytcStartTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.ytcEndTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.ytcTime).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.ytcStartTime = start.format('YYYY-MM-DD HH:mm');
                    _this.ytcEndTime = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 初始化门店输入框
            innitInput: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                if (v.id != '0') {
                                    _this.shopDatas.push({
                                        id: v.id,
                                        text: v.name
                                    });
                                }
                            });
                            $(_this.$refs.ytcShop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                // 支付类型
                                _this.getPayType(e.params.data.id);
                                _this.getStaffList(e.params.data.id);
                                // 组别
                                _this.group_txt = ''
                                _this.group_checkboxModel = []
                                _this.getGroupData()
                                _this.setShopDefaultTime(e.params.data.id);
                            });
                            $(_this.$refs.ytcShop).val(data.response.result[1].id).trigger('change');
                            _this.getPayType(data.response.result[1].id)
                            _this.getStaffList(data.response.result[1].id)
                            _this.setShopDefaultTime(data.response.result[1].id)
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },

             // 获取支付类型
            getPayType: function(shop_id) {
                const _this = this;

                Vue.axios.post('Order/getAllPayPlatform', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id,
                            "api_type": "pson_recharge"
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.pay_type_list = [{
                            id: '0',
                            text: '全部'
                        }];
                        for(let [key, value] of Object.entries(res.data.response.data)) {
                            _this.pay_type_list.push({id: key, text: value});
                        }
                        $(_this.$refs.ytcPayPlatform).select2({
                            data: _this.pay_type_list,
                            allowClear: true,
                            minimumResultsForSearch: -1,
                            language: "zh-CN"
                        });
                        $(_this.$refs.ytcPayPlatform).val('0').trigger('change');
                        _this.innitYtcTable();
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取员工
            getStaffList: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "User/getList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{ id: "0", text: "全部" }];
                            $.each(data.response.result.user_info, function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.staff).html("");
                            $(_this.$refs.staff).select2({
                                data: arr,
                                allowClear: true,
                                language: "zh-CN",
                                width: '100%'
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },


            // 进入选择组别
            openGroup: function() {
                this.c_group_checkboxModel = this.group_checkboxModel;
                this.group_checkboxModel = [];
                this.getGroupData();
                this.group_checkboxModel = this.c_group_checkboxModel;
                $('.ytc-list').hide();
                $('.group-panel').show();
            },
            // 获取组别列表
            getGroupData: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": '0',
                            "page_size": '0',
                            "shop_id": $(_this.$refs.ytcShop).val(),
                            "key_word": 'personnel',
                            "group_name": _this.group_name
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getGroupSearchList",
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.group_checkboxData = data.response.result;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 全选
            groupCheckedAll: function() {
                let _this = this;
                _this.group_allcheck = _this.c_group_allcheck;
                if(!_this.group_allcheck) { // 实现全选
                    _this.group_checkboxModel = [];
                    _this.group_checkboxData.forEach(function(item) {
                        _this.group_checkboxModel.push(item.group_id);
                    });
                } else { // 实现反选
                    _this.group_checkboxModel = [];
                }
            },
            // 返回
            groupBack: function() {
                $('.group-panel').hide();
                $('.ytc-list').show();
                this.group_checkboxModel = this.c_group_checkboxModel;
            },

            groupSub: function() {
                let _this = this;
                let arr = [];
                _this.group_checkboxData.forEach(function(item) {
                    _this.group_checkboxModel.forEach(function(sub) {
                        if(item.group_id == sub) {
                            arr.push(item.group_name);
                        }
                    });
                });
                _this.group_txt = arr.join(',');
                $('.group-panel').hide();
                $('.ytc-list').show();
            },


            // 表格
            innitYtcTable: function() {
                let _this = this;
                $(_this.$refs.ytcList).bootstrapTable('destroy');
                $(_this.$refs.ytcList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 15,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getYtcList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "create_time",
                        title: "台费充值时间",
                        width: "15%"
                    }, {
                        field: "stage_name",
                        title: "充值艺人姓名",
                        width: "15%",
                        formatter: function(value, row, index) {
                            return row.stage_name + '-' + row.waist_tag
                        }
                    }, {
                        field: "group_name",
                        title: "组别",
                        width: "15%"
                    }, {
                        field: "pay_platform_name",
                        title: "支付类型",
                        width: "15%"
                    }, {
                        field: "amount",
                        title: "充值金额",
                        width: "10%"
                    }, {
                        field: "refund_amount",
                        title: "退款金额",
                        width: "10%"
                    }, {
                        field: "admin_name",
                        title: "操作人",
                        width: "10%"
                    }, {
                        field: 'op',
                        title: "操作",
                        width: "10%",
                        events: {
                            'click .detail': function(e, value, row) {
                                var refundList = row.refund_log
                                _this.innitRefundcTable(refundList)
                                _this.showRefundDetail = true
                            }
                        },
                        formatter: function(value, row, index) {
                            if (row.refund_log.length > 0) {
                                return '<span class="text-blue detail">详情</span>'
                            }else {
                                return ''
                            }
                        }
                    }],
                });
            },


            getYtcList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "start_time": _this.ytcStartTime,
                            "end_time": _this.ytcEndTime,
                            "shop_id": $(_this.$refs.ytcShop).val(),
                            "pay_platform": $(_this.$refs.ytcPayPlatform).val(),
                            "group_id": _this.group_checkboxModel,
                            "search_word": _this.search_word,
                            "admin_id": $(_this.$refs.staff).val()
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport2/getPersonnelChargeOrderList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.total,
                                rows: data.response.result.rows
                            });
                            $(_this.$refs.ytc_amount).text(data.response.result.total_amount);
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取导出设置
            getYtcExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport2/chargeOrderExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.ytcExport_checkModel = data.response.result.export_fields;
                                _this.ytcExport_type = data.response.result.export_type;
                            } else {
                                _this.ytcExport_checkModel = _this.ytcExport_checkData;
                                _this.ytcExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.ytcExport_alert)
                }, function() {
                    _this.exportYtcList();
                });
            },
            // 导出字段全选
            ytcExportCheckedAll: function() {
                let _this = this;
                _this.ytcExport_allcheck = _this.c_ytcExport_allcheck;
                if(!_this.ytcExport_allcheck) { // 实现全选
                    _this.ytcExport_checkModel = [];
                    _this.ytcExport_checkData.forEach(function(item) {
                        _this.ytcExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.ytcExport_checkModel = [];
                }
            },
            // 导出
            exportYtcList: function() {
                let _this = this;
                let export_fields = JSON.stringify(_this.ytcExport_checkModel);
                window.location.href = Vue.ctUrl + "FinanceReport2/chargeOrderExport?" +
                    "&start_time=" + _this.ytcStartTime +
                    "&end_time=" + _this.ytcEndTime +
                    "&shop_id=" + $(_this.$refs.ytcShop).val() +
                    "&pay_platform=" + $(_this.$refs.ytcPayPlatform).val() +
                    "&group_id=" + _this.group_checkboxModel +
                    "&search_word=" +  _this.search_word +
                    "&admin_id=" + $(_this.$refs.staff).val() +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.ytcExport_type;
                // debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },

            // 表格
            innitRefundcTable: function(arr) {
                let _this = this;
                $(_this.$refs.refundList).bootstrapTable('destroy');
                $(_this.$refs.refundList).bootstrapTable({
                    data: arr,
                    columns: [{
                        field: "create_time",
                        title: "退款时间",
                        width: "25%"
                    }, {
                        field: "amount",
                        title: "退款金额",
                        width: "25%"
                    }, {
                        field: "admin_name",
                        title: "操作人",
                        width: "25%"
                    }, {
                        field: "remark",
                        title: "备注",
                        width: "25%"
                    }]
                });
            },
        }
    }
</script>
<style lang="less" scoped>
    /* 组别 */
    .group-panel {
        display: none;
        .group-search {
            position: relative;
            margin: 0 0 30px;
            input {
                width: 300px;
                height: 36px;
                padding: 0 45px 0 16px;
                color: #888;
                font-size: 16px;
                background: #f5f5f5;
                border-radius: 6px;
            }
            img {
                position: absolute;
                right: 10px;
                top: 6px;
                width: 24px;
                cursor: pointer;
            }
            button {
                margin: 0 30px 0 0;
            }
        }
        .group-list {
            clear: both;
            li:first-child {
                width: 100%;
                input {
                    margin: 2px 10px 0 0;
                }
            }
            li {
                float: left;
                width: 20%;
                margin: 0 0 30px;
                font-size: 14px;
                input {
                    float: left;
                    margin: 2px 10px 0 30px;
                }
                label {
                    margin: 0;
                    font-weight: normal;
                }
            }
        }
        .row {
            button {
                margin: 0 30px 0 0;
            }
        }
    }
</style>